import { render, staticRenderFns } from "./personnalisationRessources.vue?vue&type=template&id=e5736c8c&scoped=true"
import script from "./personnalisationRessources.vue?vue&type=script&lang=js"
export * from "./personnalisationRessources.vue?vue&type=script&lang=js"
import style0 from "./personnalisationRessources.vue?vue&type=style&index=0&id=e5736c8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5736c8c",
  null
  
)

export default component.exports